module.exports = __webpack_public_path__ + "static/media/github-green.26cc5e4c.svg";